var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.detail)?[_c('div',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.detail.title))]),_c('div',{staticClass:"helper-content",domProps:{"innerHTML":_vm._s(_vm.detail.content)}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }